export const brazeConfig: {
  [key: string]: {
    apiKey: string
    endpoint: string
    safariPushId: string
    enableLogging: boolean
  }
} = {
  prod: {
    apiKey: 'e6577fac-30b0-4270-a5df-788ef16dc4cd',
    endpoint: 'sdk.fra-01.braze.eu',
    safariPushId: 'web.com.carrefour.website',
    enableLogging: false
  },
  uat1: {
    apiKey: '53640f15-994a-424a-a0d4-69701fa67ae0',
    endpoint: 'sdk.fra-01.braze.eu',
    safariPushId: 'web.com.carrefour.website',
    enableLogging: true
  },
  uat2: {
    apiKey: '53640f15-994a-424a-a0d4-69701fa67ae0',
    endpoint: 'sdk.fra-01.braze.eu',
    safariPushId: 'web.com.carrefour.website',
    enableLogging: true
  },
  uat0: {
    apiKey: '53640f15-994a-424a-a0d4-69701fa67ae0',
    endpoint: 'sdk.fra-01.braze.eu',
    safariPushId: 'web.com.carrefour.website',
    enableLogging: true
  }
}
